export default __webpack_public_path__ + "static/media/Dinesh.273c2f57.png";